// extracted by mini-css-extract-plugin
module.exports = {"social-icon":"V7sBLQZ","socialIcon":"V7sBLQZ","social-label":"h8af_kC","socialLabel":"h8af_kC","facebook":"t60B9CV","twitter":"l2KLnDV","google":"z6KogMK","linkedin":"ha3gUpc"};